import { ThemeProvider } from '@mui/material';
import { useAppTheme } from './hooks';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/de';
import 'moment/locale/nl';
import 'moment/locale/nb';
import 'moment/locale/fr';
import 'moment/locale/sr';
import { useLocale } from 'utils/hooks/useLocale';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const AppThemeProvider = ({ children }: any) => {
  const theme = useAppTheme();
  const { locale } = useLocale();
  const { t } = useTranslation();

  const localizationProviderProps = useMemo(
    () => ({
      dateAdapter: AdapterMoment,
      adapterLocale: locale || 'en',
      localeText: {
        clearButtonLabel: t('Clear'),
      },
    }),
    [locale, t]
  );

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider {...localizationProviderProps}>
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  );
};
